export interface VersionRequirements {
  os: OSType;
  minimumallowedversion: number;
  latestRecommendedVersion: number;
}

export enum OSType {
  iOS = 'iOS',
  android = 'Android',
  macOS = 'macOS',
  windows = 'Windows 10',
}
